import { FractionTypeNames } from '~/bootcamp/Activities/Fractions/Fractions.type'
import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  quotient?: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

export interface FractionTypesQuestionModel {
  type: string
  numerator: number
  denominator: number
  quotient: number
  maxVariation: number
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 1, max: 10 }, denominator: { min: 2, max: 8 }, variation: 70 },
  2: { numerator: { min: 1, max: 10 }, denominator: { min: 2, max: 8 }, quotient: { min: 1, max: 5 }, variation: 350 },
}

export function getFractionTypeQuestionData(difficultyLevel: number, excludes?: string[]): FractionTypesQuestionModel {
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]

  let quotient = range?.quotient ? getRandomInt(range.quotient.min, range.quotient.min) : 0
  quotient = Math.random() < 0.5 ? quotient : 0 // 50% change of getting a quotient
  const denominator = getRandomInt(range.denominator.min, range.denominator.max)
  const numerator = quotient
    ? getRandomInt(range.numerator.min, denominator - 1)
    : getRandomInt(range.numerator.min, range.numerator.max, [denominator])

  let fractionType = FractionTypeNames.IMPROPER
  if (quotient) {
    fractionType = FractionTypeNames.MIXED
  } else if (numerator < denominator) {
    fractionType = FractionTypeNames.PROPER
  }
  const key = `${quotient}-${numerator}-${denominator}`
  if (excludes && excludes.includes(key)) return getFractionTypeQuestionData(difficultyLevel, excludes)

  return { type: fractionType, numerator, denominator, quotient, maxVariation: range.variation }
}
